module.exports = __webpack_public_path__ + "static/media/icon-total-2.bdcbce45.svg";